import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import Artist from '../video-production/Artist';
import React, { useEffect, useState } from 'react';
const VoiceArtistsSlider = props => {
  let [isEntered, setIsEntered] = useState(false);
  let settings = {
    infiniteLoop: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: false,
    dots: false,
    waitForAnimate: false,
    swipe: true,
    centerPadding: '70px',
    variableWidth: false,
    fade: false,
    autoplay: true,
    autoplaySpeed: 6000,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const [playedId, setPlayedId] = useState('');
  const artists = [
    {
      accent: {
        accent_image: '/uploads/images/accents/62693112a555c1651061010.svg',
        accent_name: 'American',
      },
      age: 'Middle-aged Adult',
      attached_sound: 'https://admin.weprodigi.com/uploads/images/video-production/AnthonySantora(US).mp3',
      image: 'https://admin.weprodigi.com/uploads/images/video-production/american-man.png',
      display_name: 'American male artist',
      id: 48,
      language: 'American',
    },
    {
      accent: {
        accent_image: '/uploads/images/accents/62693112a376f1651061010.svg',
        accent_name: 'American',
      },
      age: 'Young',
      attached_sound: 'https://admin.weprodigi.com/uploads/images/video-production/Amberote(US,C).mp3',
      image: 'https://admin.weprodigi.com/uploads/images/video-production/canadian-girl.png',
      display_name: 'Canadian female artist',
      artist_name: 'Halley Mareec Clure',
      gender: '1',
      id: 33,
      language: 'American',
    },
    {
      accent: {
        accent_image: '/uploads/images/accents/62693112a63d31651061010.svg',
        accent_name: 'American',
      },
      age: 'Middle-aged Adult',
      attached_sound: 'https://admin.weprodigi.com/uploads/images/video-production/Carlraser(Uk).mp3',
      image: 'https://admin.weprodigi.com/uploads/images/video-production/uk-man.png',
      display_name: 'British male artist',
      gender: '1',
      id: 30,
      language: 'American',
    },
    {
      accent: {
        accent_image: '/uploads/images/accents/62693112a47311651061010.svg',
        accent_name: 'American',
      },
      age: 'Young',
      attached_sound: 'https://admin.weprodigi.com/uploads/images/video-production/JackieBowker(US)AS.mp3',
      image: 'https://admin.weprodigi.com/uploads/images/video-production/Australian-girl.png',
      display_name: 'Australian female artist',
      artist_name: 'Halley Mareec Clure',
      gender: '1',
      id: 31,
      language: 'American',
    },

    {
      accent: {
        accent_image: '/uploads/images/accents/62693112a555c1651061010.svg',
        accent_name: 'American',
      },
      age: 'Young',
      attached_sound: 'https://admin.weprodigi.com/uploads/images/video-production/HalleyMareecClure(US).wav',
      image: 'https://admin.weprodigi.com/uploads/images/video-production/american-girl.png',
      display_name: 'American female artist',
      artist_name: 'Halley Mareec Clure',
      gender: '1',
      id: 47,
      language: 'American',
    },
    {
      accent: {
        accent_image: '/uploads/images/accents/62693112a63d31651061010.svg',
        accent_name: 'American',
      },
      age: 'Senior Adult',
      attached_sound: 'https://admin.weprodigi.com/uploads/images/video-production/NicolaProctor(UK).wav',
      image: 'https://admin.weprodigi.com/uploads/images/video-production/uk-girl.png',
      display_name: 'British female artist',
      gender: '1',
      id: 49,
      language: 'American',
    },

    {
      accent: {
        accent_image: '/uploads/images/accents/62693112a376f1651061010.svg',
        accent_name: 'American',
      },
      age: 'Middle-Aged Adult',
      attached_sound: 'https://admin.weprodigi.com/uploads/images/video-production/ChrisBoudreau(US,C).mp3',
      image: 'https://admin.weprodigi.com/uploads/images/video-production/canadian-man.png',
      display_name: 'Canadian male artist',
      artist_name: 'Halley Mareec Clure',
      gender: '1',
      id: 34,
      language: 'American',
    },

    {
      accent: {
        accent_image: '/uploads/images/accents/62693112a47311651061010.svg',
        accent_name: 'American',
      },
      age: 'Senior Adult ',
      attached_sound: 'https://admin.weprodigi.com/uploads/images/video-production/AlanGlass(US).mp3',
      image: 'https://admin.weprodigi.com/uploads/images/video-production/Australian-man.png',
      display_name: 'Australian male artist',
      artist_name: 'Halley Mareec Clure',
      gender: '1',
      id: 32,
      language: 'American',
    },
  ];
  useEffect(() => {
    if (!playedId) {
      if (isEntered) settings.autoplay = false;
      else settings.autoplay = true;
    }
  }, [isEntered]);
  useEffect(() => {
    if (playedId) settings.autoplay = false;
  }, [playedId]);
  return (
    <>
      <style jsx global>{`
        .hover-arrow {
          transition: all 0.5s;
        }

        .hover-arrow:hover {
          transform: scale(1.05);
          transition: all 0.5s;
        }
        .hover-arrow:hover svg {
          transform: rotate(360deg);
          transition: all 0.5s;
        }
      `}</style>
      <div
        className="flex flex-col gap-[48px]"
        onMouseEnter={() => setIsEntered(true)}
        onMouseLeave={() => {
          setIsEntered(false);
        }}
      >
        <Slider {...settings} className="process-slider relative z-10">
          {artists.map((art, id) => {
            return (
              <div className={'pr-15'}>
                <Artist
                  played={playedId == 'list_' + art.id}
                  from={'list'}
                  key={'artist_' + art.id}
                  setPlayedId={setPlayedId}
                  className={'ml-0 md:ml-0 mt-10'}
                  data={art}
                />
              </div>
            );
          })}
        </Slider>
        <div className="flex justify-end pt-23 md:pt-0">
          <a aria-label="review" href="/voiceover/0XcrYB" className={' text-purple flex text-18 md:text-20 font-bolder leading-24 hover-arrow'}>
            <span className="hidden md:block">View More Voice Options</span>
            <span className="block md:hidden">More Options</span>
            <svg xmlns="http://www.w3.org/2000/svg" width={25} viewBox="0 0 20 20" fill="currentColor">
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </a>
        </div>
      </div>
    </>
  );
};

export default VoiceArtistsSlider;
